import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { SitewideEntity } from '../../models/shared/sitewide.entities';
import * as StatusTrackerActions from '../actions/status-tracker.actions';
import {
  loadAEMContentFailure,
  loadAEMContentSuccess,
  loadAEMErrorMessagesFailure,
  loadAEMErrorMessagesSuccess,
  loadAEMSummaryContentFailure,
  loadAEMSummaryContentSuccess,
  loadFutureActivityFailure,
  loadFutureActivitySuccess
} from '../actions/status-tracker.actions';

export const STATUS_TRACKER_FEATURE_KEY = 'statusTracker';

export interface State extends EntityState<SitewideEntity> {
  selectedId?: string | number; // which Overview record has been selected
  loaded: boolean; // has the Overview list been loaded
  error?: string | null; // last known error (if any)
}

export const statusTrackerAdapter: EntityAdapter<SitewideEntity> =
  createEntityAdapter<SitewideEntity>();

export const initialState: State = statusTrackerAdapter.getInitialState({
  loaded: false
});

const statusTrackerReducer = createReducer(
  initialState,

  on(StatusTrackerActions.loadStatusTrackerSuccess, (state, { tracker }) =>
    statusTrackerAdapter.setOne(tracker, { ...state, loaded: true })
  ),
  on(StatusTrackerActions.loadStatusTrackerFailure, (state, { error }) => {
    return statusTrackerAdapter.setOne(error, { ...state, loaded: true });
  }),
  on(loadAEMContentSuccess, (state, { aemStatusTracker }) =>
    statusTrackerAdapter.setOne(aemStatusTracker, { ...state, loaded: true })
  ),
  on(loadAEMContentFailure, (state, { error }) =>
    statusTrackerAdapter.setOne(error, {
      ...state,
      loaded: true
    })
  ),
  on(
    loadAEMSummaryContentSuccess,
    (state, { aemStatusTrackerSummaryContent }) =>
      statusTrackerAdapter.setOne(aemStatusTrackerSummaryContent, {
        ...state,
        loaded: true
      })
  ),
  on(loadAEMSummaryContentFailure, (state, { error }) =>
    statusTrackerAdapter.setOne(error, {
      ...state,
      loaded: true
    })
  ),
  on(loadFutureActivitySuccess, (state, { futureActivities }) =>
    statusTrackerAdapter.setOne(futureActivities, {
      ...state,
      loaded: true
    })
  ),
  on(loadFutureActivityFailure, (state, { error }) => {
    return statusTrackerAdapter.setOne(error, {
      ...state,
      loaded: true
    });
  }),
  on(loadAEMErrorMessagesSuccess, (state, { aemErrorMessages }) =>
    statusTrackerAdapter.setOne(aemErrorMessages, { ...state, loaded: true })
  ),
  on(loadAEMErrorMessagesFailure, (state, { aemErrorMessagesError }) =>
    statusTrackerAdapter.setOne(aemErrorMessagesError, {
      ...state,
      loaded: true
    })
  )
);

export const reducer = (state: State | undefined, action: Action) =>
  statusTrackerReducer(state, action);
